import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'

class DropdownItem extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
    this.bindHandlers()
  }

  bindHandlers () {
    this.handleMouseOver = this.handleMouseOver.bind(this)
    this.handleMouseOut = this.handleMouseOut.bind(this)
  }

  handleMouseOver () {
    this.props.onMouseOver(this.props.index)
  }

  handleMouseOut () {
    this.props.onMouseOut()
  }

  render () {
    return (
      <li
        style={{
          ...styles.base,
          ...this.props.hover && styles.hover,
          ...this.props.active && styles.active
        }}
        onMouseOver={this.handleMouseOver}
        onMouseOut={this.handleMouseOut}
      >
        {this.props.value}
      </li>
    )
  }
}

DropdownItem.defaultProps = {
  active: false,
  hover: false
}

DropdownItem.propTypes = {
  index: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  onMouseOut: PropTypes.func.isRequired,
  active: PropTypes.bool,
  hover: PropTypes.bool
}

export default DropdownItem
